var React = require('react');

function WarningIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#E64F41","fillRule":"evenodd","d":"M8.17 2a6.17 6.17 0 100 12.34A6.17 6.17 0 008.17 2zM0 8.17a8.17 8.17 0 1116.34 0A8.17 8.17 0 010 8.17zM8.17 4.3a1 1 0 011 1v2.87a1 1 0 11-2 0V5.3a1 1 0 011-1zm0 5.74a1 1 0 100 2 1 1 0 000-2z","clipRule":"evenodd"}));
}

WarningIcon.defaultProps = {"fill":"none","viewBox":"0 0 17 17"};

module.exports = WarningIcon;

WarningIcon.default = WarningIcon;
